export class MapConstants {
  public static readonly MAX_MAP_LAYERS = 6;
}
